import "./KeywordsManagement.css";
import React, {memo, useState} from "react";
import {DataLoadingStatus} from "../../../Utils/enums";
import {
    getDivisionsFull,
} from "../../../Utils/queries";
import {DivisionFull} from "../../../Utils/response-types";
import SelectDivisionPanel from "./SelectDivisionPanel";
import AttributesNav from "./AttributesNav";
import DivisionDisplay from "./DivisionDisplay";

const KeywordsManagement = () => {
    const [divisions, setDivisions] = useState<DivisionFull[]>([]);
    const [selectedDivisionId, setSelectedDivisionId] = useState<number>(-1);
    const [status, setStatus] = useState<DataLoadingStatus>(DataLoadingStatus.NotLoaded);

    if (status === DataLoadingStatus.NotLoaded) {
        setStatus(DataLoadingStatus.Loading);
        getDivisionsFull().then(resp => {
            if (resp.errorCode === undefined) {
                setDivisions(resp.divisions);
                if (selectedDivisionId === -1 && resp.divisions.length > 0) {
                    setSelectedDivisionId(0);
                }
                setStatus(DataLoadingStatus.Loaded);
            } else {
                setStatus(DataLoadingStatus.Error);
            }
        });
    }

    return (
        <div className="main-content">
            <AttributesNav selectedDivision={divisions[selectedDivisionId]} setDivisions={setDivisions} status={status} setStatus={setStatus}/>
            <div className="kw-management-main">
                <SelectDivisionPanel divisions={divisions} setDivisions={setDivisions} selectedIdx={selectedDivisionId} setSelectedIdx={setSelectedDivisionId} setStatus={setStatus} />
                {selectedDivisionId !== -1 && selectedDivisionId < divisions.length && <DivisionDisplay activeDivision={divisions[selectedDivisionId]} setDivisions={setDivisions} status={status} setStatus={setStatus} />}
            </div>
        </div>
    );
};


export default memo(KeywordsManagement);